import { render, staticRenderFns } from "./MainLeftpart.vue?vue&type=template&id=16f450b3&scoped=true"
import script from "./MainLeftpart.vue?vue&type=script&lang=js"
export * from "./MainLeftpart.vue?vue&type=script&lang=js"
import style0 from "./MainLeftpart.vue?vue&type=style&index=0&id=16f450b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f450b3",
  null
  
)

export default component.exports